import { motion } from "framer-motion";
import { FaWandMagicSparkles } from "react-icons/fa6";
import { ReactComponent as AboutHero } from "../../../../../images/web/about/about-hero-svg.svg";
import Constaint from "../../../layout/components/Constaint";

const Hero = () => {
  return (
    <Constaint>
      <section className="relative overflow-hidden bg-white w-full">
        {/* Ambient blobs — behind everything */}
        <div className="pointer-events-none absolute -left-24 top-0 h-80 w-80 rounded-full bg-blue-ea/60 blur-3xl" />
        <div className="pointer-events-none absolute -right-24 bottom-0 h-96 w-96 rounded-full bg-blue-00/8 blur-3xl" />

        <div className="flex flex-col lg:flex-row lg:min-h-svh lg:items-center">
          {/* Content */}
          <div className="relative w-full lg:w-3/5 py-24 lg:py-32">
              <motion.div
                initial={{ opacity: 0, y: 28 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.65 }}
              >
                <p className="inline-flex items-center gap-2 rounded-full border border-blue-ea bg-white px-4 py-2 text-xs font-semibold uppercase tracking-widest text-blue-00">
                  <FaWandMagicSparkles className="h-3.5 w-3.5" />
                  About Us
                </p>

                <h1 className="mt-6 text-h1 font-light font-lato tracking-tight text-black-1a">
                  About
                  <span className="mx-2 inline-flex rotate-2 rounded-3xl border-8 border-blue-ea bg-blue-00 px-4 pb-1 text-white shadow-sm transition-all duration-300 hover:rotate-0">
                    SeamlessVisa
                  </span>
                </h1>

                <p className="mt-6 text-lg leading-8 text-dark-6b">
                  SeamlessVisa is a technology-powered global mobility company
                  specializing in international education admissions, visa
                  processing, and consular interview preparation. We serve
                  individuals, families, and organizations worldwide, guiding
                  them through study abroad programs across top destinations,
                  and international visa pathways covering student, dependent,
                  travel, and employment-based categories.
                </p>

                <p className="mt-4 text-lg leading-8 text-dark-6b">
                  Our approach rests on three pillars: strategic expertise,
                  intelligent technology, and personalized support —
                  consistently delivering stronger applications, higher approval
                  rates, and clients who arrive at their interviews prepared and
                  confident.
                </p>

                <p className="mt-4 text-lg leading-8 text-dark-6b">
                  We don't just process applications. We engineer successful
                  journeys.
                </p>

                <div className="mt-8 flex flex-wrap gap-3">
                  {[
                    "Global Mobility",
                    "Visa Processing",
                    "Study Abroad",
                    "FiBi AI",
                  ].map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-blue-ea px-4 py-1.5 text-sm font-medium text-blue-00"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </motion.div>
          </div>

          {/* SVG — column on mobile, overlay on desktop */}
          <div className="relative w-full lg:absolute lg:inset-y-0 lg:right-0 lg:w-2/5 h-64 lg:h-full lg:pointer-events-none">
            {/* Fade edge for desktop overlay */}
            <div className="hidden lg:block absolute inset-y-0 left-0 w-40 bg-gradient-to-r from-white to-transparent z-10" />
            <AboutHero className="h-full w-full object-cover" />
          </div>
        </div>
      </section>
    </Constaint>
  );
};

export default Hero;
